import constructSizeForm from 'utils/constructSizeForm'
import toPixels from 'utils/toPixels'

export default function resetSizesForUnit({ props, state }) {
  const basketItems = state.get('basket.basketItems')
  const unit = state.get('basket.unit')
  Object.keys(basketItems).forEach(item => {
    const { ratio, target, form, orderItemId } = basketItems[item]
    if (form) {
      state.set(
        `basket.basketItems.${orderItemId}.form`,
        constructSizeForm(
          unit,
          ratio,
          target,
          toPixels(props.oldUnit, target.dpi, form.width.value)
        )
      )
    }
  })
}



// WEBPACK FOOTER //
// ./src/modules/Basket/actions/resetSizesForUnit.js